'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dSymbol from "./scala.-Symbol.js";
import * as $j_scala$002escalajs$002ejs$002e$002dWrapped$002dDictionary$0024$002dCache$0024 from "./scala.scalajs.js.-Wrapped-Dictionary$-Cache$.js";
var $p;
function $ct_s_UniquenessCache__($thiz) {
  $thiz.An = ({});
  return $thiz;
}
export { $ct_s_UniquenessCache__ as $ct_s_UniquenessCache__ };
/** @constructor */
function $c_s_UniquenessCache() {
  this.An = null;
}
export { $c_s_UniquenessCache as $c_s_UniquenessCache };
$p = $c_s_UniquenessCache.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_UniquenessCache;
/** @constructor */
function $h_s_UniquenessCache() {
}
export { $h_s_UniquenessCache as $h_s_UniquenessCache };
$h_s_UniquenessCache.prototype = $p;
$p.O3 = (function(name) {
  var dict = this.An;
  if ((!(!$j_scala$002escalajs$002ejs$002e$002dWrapped$002dDictionary$0024$002dCache$0024.$m_sjs_js_WrappedDictionary$Cache$().tM.call(dict, name)))) {
    return dict[name];
  } else {
    var v = new $j_scala$002e$002dSymbol.$c_s_Symbol(name);
    dict[name] = v;
    return v;
  }
});
